<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="500px"
    @close="$router.replace('/lists')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="customsTariffNumber"
      :rules="rules"
      ref="customsTariffNumberForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="value"
        label="Érték"
        :error="errors.value ? errors.value[0] : null"
      >
        <el-input v-model="customsTariffNumber.value" />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/lists')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    props: ['type', 'customsTariffNumberId'],
    data() {
      const checkValue = (rule, value, callback) => {
        if (isNaN(parseFloat(value)) || (typeof value === 'string' && !value.match(/^\d*\.?\d*?$/))) {
          return callback(new Error('Ez a mező csak számokat tartalmazhat'));
        }
        return callback();
      };
      return {
        loading: false,
        buttonLoading: false,
        errors: {
          value: null,
        },
        customsTariffNumber: {},
        rules: {
          value :[
            { required: true, message: 'Érték megadása kötelező', trigger: 'blur' },
            { validator: checkValue, trigger: 'change' },
          ]
        }
      }
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új Vámtarifaszám';
        } else if (this.type === 'update') {
          return 'Vámtarifaszám módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadás';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },

    methods: {
      async add() {
        this.$refs['customsTariffNumberForm'].validate(async valid => {
          if(valid) {
            this.errors.value = null;
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('customsTariffNumber/add', this.customsTariffNumber);
              } else if (this.type === 'update') {
                await this.$store.dispatch('customsTariffNumber/update', this.customsTariffNumber);
              }
              this.$store.dispatch('customsTariffNumber/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/lists');
            } catch (e) {
              if (e.data && e.data.errors) {
                this.errors = e.data.errors;
              }
            }
            this.buttonLoading = false;
          }
        });
      }
    },

    async mounted() {
      this.loading = true;
      if(this.customsTariffNumberId) {
        this.customsTariffNumber = await this.$store.dispatch('customsTariffNumber/fetch', this.customsTariffNumberId);
      }
      this.loading = false;
    }
  }
</script>
